import React from "react";
import { RouteObject } from "../../interfaces/navigation";

const EntryPoint = React.lazy(() => import("../../containers/Publication/EntryPointContainer"));

export const publicationRoutes: RouteObject[] = [
    {
        title: "publication",
        path: "/publication/:id",
        component: <EntryPoint />,
        protected: true
    }
];